import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBrand } from 'app/models/vehicle.model';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CatalogService {

  apiUrl: string = `${environment.apiUrl}brand`;
  //  'http://localhost:3000/brand';

  constructor(private client: HttpClient) { }

  public async getBrands(){
    return await this.client.get<IBrand[]>(this.apiUrl).toPromise();
  }
}
